module.exports = __webpack_public_path__ + "static/img/9.9dc2734.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/4/2/sp/9.png
// module id = DNlG
// module chunks = 0